module.exports = __webpack_public_path__ + "img/document.62ba92c5.svg";